import loadable from "@loadable/component";

import(/* webpackChunkName: "semantic-theme" */"@semantic-theme").then(()=>{});
import React from 'react'
import { TransitionablePortal, Container, Icon, Divider } from 'semantic-ui-react'
import { ROOT_ID } from '~/config'
import styled from "styled-components";
import { Box, Flex } from 'rebass'

import { STATE_CONTACT, STATE_PAYMENT, STATE_SUMMARY, STATE_ORDERED, STATE_DELIVERY } from "~/constants/cart";
import WholeScreenLoader from '~/components/whole-screen-loader';
import PoweredBy from '~/components/powered-by'
import BlockingButton from '~/components/button'
import sizes from '~/components/sizes'
import { Count } from '~/components/cart'
import { CheckoutErrorBoundary } from '~/components/errors'

import { __ } from '~/i18n'

import logic from './logic'
import Summary from './summary'
import Steps from './steps'

const CheckoutContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 99999;
  background: #FFFFFF;
  overflow: auto;
  > div {
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }
`;

const PoweredByContainer = styled.div`
  flex-shrink: 0;
  margin-top: auto;
`;

const CloseButtonContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 100;
`;

const SmallerContainer = styled(Container)`
  @media (min-width: 1200px) {
    &.ui.container {
      width: 1070px;
    }
  }
`;

const ContentsContainer = styled(SmallerContainer)`
  margin-top: 48px;
  
  @media (max-width: 768px) {
    margin-top: 0px;
  }
`;

const StepsContainer = styled.div`
  padding: 25px 0 11px;
`;

const OrderSummaryView = styled.div`
  
`;

const Buttons = styled.div`
  padding: 0 16px;
`;

const MobileCloseContainer = styled.div`
  position: absolute;
  left: 15px;
  top: 22px;
  z-index: 150;
`;

const ShowOrderSummary = styled.div`
  cursor: pointer;
  text-align: left;
  padding: 20px 24px 20px;
  font-weight: bold;
  font-size: 16px;
  color: #1B2125;
  line-height: 24px;
  
  .inner {
    padding: 0 0 20px;
    position: relative;
  }
`;

const LoadableContact = loadable(() => import(/* webpackChunkName: "contact" */ '../contact'), {fallback: <WholeScreenLoader />});
const LoadableShipping = loadable(() => import(/* webpackChunkName: "shipping" */ '../shipping'), {fallback: <WholeScreenLoader />});
const LoadablePayment = loadable(() => import(/* webpackChunkName: "payment" */ '../payment'), {fallback: <WholeScreenLoader />});
const LoadableSummary = loadable(() => import(/* webpackChunkName: "summary" */ '../summary'), {fallback: <WholeScreenLoader />});
const LoadableOrder = loadable(() => import(/* webpackChunkName: "order" */ '../order'), {fallback: <WholeScreenLoader />});

@sizes
@logic
export default class Checkout extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      orderSummaryVisible: false,
      error: false
    }

    this._mountNode = document.getElementById(ROOT_ID)
  }

  componentDidMount() {
    const { visible } = this.props;

    setTimeout(() => {
      this.setVisibility(visible);
    }, 0)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.setVisibility(this.props.visible);
  }

  handleError = () => {
    this.setState({error: true})
  };

  setVisibility = (visibility) => {
    const { visible } = this.state;

    if(visibility !== visible) {
      this.setState({visible: visibility});
    }
  };

  handleClose = () => {
    this.removeBodyClasses();
  };

  handleCloseClick = () => {
    const { closeCart } = this.props.actions;

    closeCart();
    this.removeBodyClasses();
  };

  handleOpen = () => {
    this.addBodyClasses();
  };

  handleSummaryClose = () => {
    this.setState({orderSummaryVisible: false})
  };

  handleSummaryOpen = () => {
    this.setState({orderSummaryVisible: true})
  };

  addBodyClasses = () => {
    try {
      document.body.classList.add('dimmable', 'dimmed', 'scrolling')
    } catch (e) {
      console.log('error',e);
    }
  };

  removeBodyClasses = () => {
    try {
      document.body.classList.remove('dimmable', 'dimmed', 'scrolling')
    } catch (e) {

    }
  };

  handleBack = () => {
    const { previous, hideCheckout } = this.props;

    if(hideCheckout) {
      this.setVisibility(false);
      this.removeBodyClasses();
    }
    previous();
  };

  handleNavigate = (step, action) => {
    const { navigate } = this.props.actions;

    console.log('navigate', step, action);
    navigate(step, action);
  };

  getContent = () => {
    const { currentStep } = this.props;
    switch(currentStep) {
      case STATE_CONTACT:
        return <LoadableContact onBack={ this.handleBack } />;
      case STATE_DELIVERY:
        return <LoadableShipping onBack={ this.handleBack } />;
      case STATE_PAYMENT:
        return <LoadablePayment onBack={ this.handleBack } />;
      case STATE_SUMMARY:
        return <LoadableSummary onBack={ this.handleBack } />;
      case STATE_ORDERED:
        return <LoadableOrder onBack={ this.handleBack } />;
      default:
        return null;
    }
  }

  render() {
    const { visible } = this.state;
    const { currentStep, activeCart, activeShop, cartItemsCount, steps, availableSteps, loading, retrying, isTiny } = this.props;
    const { orderSummaryVisible } = this.state;

    return (
      <TransitionablePortal
        onClose={this.handleClose}
        onOpen={this.handleOpen}
        open={ visible }
        transition={{animation: 'fly left', duration: 500}}
        closeOnDocumentClick={ false }
        closeOnEscape={ false }
        mountNode={ this._mountNode || undefined }
      >

          <CheckoutContainer>
            <div>
              {orderSummaryVisible && isTiny ?
                <OrderSummaryView>
                  <MobileCloseContainer>
                    <Icon name='close' onClick={ this.handleSummaryClose } link />
                  </MobileCloseContainer>
                  <Summary small={ isTiny } cart={activeCart} shop={activeShop} count={cartItemsCount}/>
                  <Buttons>
                    <BlockingButton loading={loading} fluid positive onClick={this.handleSummaryClose}>{__("Continue")}</BlockingButton>
                  </Buttons>
                </OrderSummaryView>
                  :
                <div>
                  <SmallerContainer>
                    <StepsContainer>
                      <Steps
                        currentStep={currentStep}
                        steps={steps}
                        availableSteps={availableSteps}
                        onNavigate={this.handleNavigate}
                        retrying={retrying}
                        error={ this.state.error }
                      />
                    </StepsContainer>
                  </SmallerContainer>
                  {!isTiny ?
                    <CloseButtonContainer>
                      {loading ? <Icon size="large" loading name='spinner'/> :
                        <Icon size="large" link name='close' onClick={this.handleCloseClick}/>}
                    </CloseButtonContainer>
                    : null}
                  <Divider/>
                  <ContentsContainer>
                    <CheckoutErrorBoundary onError={ this.handleError }>
                      {isTiny ?
                        <div>
                          <ShowOrderSummary onClick={ this.handleSummaryOpen }>
                            <div className="inner">
                              { __('Show order summary') }
                              <Count count={ cartItemsCount }/>
                            </div>
                          </ShowOrderSummary>
                          { this.getContent() }
                        </div>
                        : (
                          <Flex flexWrap='wrap' py={ 4 } mx={ -6 }>
                            <Box px={ 6 } py={ 6 } width={currentStep !== STATE_ORDERED ? 10/16 : 1}>
                              {this.getContent()}
                            </Box>
                            {currentStep !== STATE_ORDERED ? (
                              <Box px={ 6 } width={ 6/16 }>
                                <Summary cart={activeCart} shop={activeShop} count={cartItemsCount}/>
                              </Box>
                            )
                            : null}
                          </Flex>
                        )
                      }
                    </CheckoutErrorBoundary>
                  </ContentsContainer>
                </div>
              }
              <PoweredByContainer>
                <PoweredBy/>
              </PoweredByContainer>
            </div>
          </CheckoutContainer>
      </TransitionablePortal>
    )
  }
}
